module.exports = __webpack_public_path__ + "static/media/11_crisalide.00bd465d.jpg";